import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useMemo, useCallback } from 'react';
import { createContext } from 'use-context-selector';
import { jsx } from '@emotion/react';

var EditorContext = createContext(null);
function EditorContextProvider(props) {
  var value = props.value,
    newValue = props.newValue,
    editorType = props.editorType,
    components = props.components,
    displayDate = props.displayDate,
    children = props.children;
  var propsRef = useRef(props);
  propsRef.current = props;
  var _useState = useState(function () {
      return {
        cursor: [],
        displayMode: editorType === 'editor' ? 'edit' : 'view',
        editorType: editorType,
        displayDate: displayDate
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    innerState = _useState2[0],
    setInnerState = _useState2[1];
  var state = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, innerState), {}, {
      document: value
    });
  }, [innerState, value]);
  var stateRef = useRef(state);
  stateRef.current = state;
  var getState = useCallback(function () {
    return stateRef.current;
  }, []);
  var setState = useCallback(function (value) {
    var nextState;
    if (typeof value === 'function') {
      nextState = value(stateRef.current);
    } else {
      nextState = value;
    }
    setInnerState({
      cursor: nextState.cursor,
      tempCursor: nextState.tempCursor,
      displayMode: nextState.displayMode,
      editorType: nextState.editorType,
      displayDate: nextState.displayDate
    });
    if (propsRef.current.value !== nextState.document) {
      var _propsRef$current$onC, _propsRef$current;
      (_propsRef$current$onC = (_propsRef$current = propsRef.current).onChange) === null || _propsRef$current$onC === void 0 || _propsRef$current$onC.call(_propsRef$current, nextState.document);
    }
  }, []);
  var contextDataRef = useRef(null);
  var dispatch = useCallback(function (command) {
    command.exec(contextDataRef.current);
  }, []);
  var contextData = {
    components: components,
    state: state,
    getState: getState,
    setState: setState,
    dispatch: dispatch,
    newDocument: newValue
  };
  contextDataRef.current = contextData;
  return jsx(EditorContext.Provider, {
    value: contextData
  }, children);
}

export { EditorContext, EditorContextProvider };
//# sourceMappingURL=EditorContext.js.map
